import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { setFilterState, setSelectedSavedFilter } from "store/features";

import { useSelectedProject } from "components/project/projects/hooks";
import { useUserSettingsDefaultsQuery } from "components/user/queries";

import { useProjectSavedFiltersQuery } from "../useProjectSavedFiltersQuery";

export function useClearFilter() {
  const dispatch = useDispatch();
  const { selectedProject: project } = useSelectedProject();

  const [isClearingFilter, setIsClearingFilter] = useState(false);
  const [currentProjectId, setProjectId] = useState(project?.projectId);

  // EVA-257: the AWS-shaped list. Clearing a view falls back to System Default
  // by name and applies the body it finds, so the raw Apollo rows would restore
  // the UDM-incompatible filter and empty the map.
  const savedFiltersQuery = useProjectSavedFiltersQuery();

  const userSettingsDefaultsQuery = useUserSettingsDefaultsQuery();

  const clearFilter = (nextProjectId) => {
    setIsClearingFilter(true);
    setProjectId(nextProjectId);
  };

  useEffect(() => {
    if (
      isClearingFilter &&
      currentProjectId === project?.projectId &&
      userSettingsDefaultsQuery.isSuccess
    ) {
      const defaultUserFilterId =
        userSettingsDefaultsQuery?.data?.Filter?.DefaultFilter?.filterId;

      const defaultUserFilter = savedFiltersQuery.savedFilters.find(
        (f) => f?.id === defaultUserFilterId
      );

      const defaultFilter = savedFiltersQuery.savedFilters.find(
        (f) => f?.name === "System Default"
      );

      const nextFilter = defaultUserFilter || defaultFilter;

      if (!nextFilter) return;

      dispatch(setSelectedSavedFilter(nextFilter));
      const parsedFilter = JSON.parse(nextFilter.filterJSON);
      dispatch(setFilterState(parsedFilter));
      setIsClearingFilter(false);
    }
  }, [
    savedFiltersQuery.savedFilters,
    userSettingsDefaultsQuery.isSuccess,
    userSettingsDefaultsQuery.data,
    isClearingFilter,
    currentProjectId,
    project?.projectId
  ]);

  return {
    update: clearFilter,
    isLoading: savedFiltersQuery.loading && userSettingsDefaultsQuery.isLoading
  };
}
